import { useState } from "react";
import { legalLinkLanguage, legalLinks } from "@/lib/legal";
import { useT } from "@/lib/i18n";
import { useLanguage } from "@/lib/language";
import { Button } from "./ui/button";

const STORAGE_KEY = "cookie_consent";

function hasConsent() {
  try { return window.localStorage.getItem(STORAGE_KEY) === "1"; } catch { return false; }
}

export function CookieConsent() {
  const [visible, setVisible] = useState(() => !hasConsent());
  const language = useLanguage();
  const t = useT();
  if (!visible) return null;
  const policy = legalLinks.privacy(language);

  function accept() {
    try { window.localStorage.setItem(STORAGE_KEY, "1"); } catch { /* the banner just reappears next visit */ }
    setVisible(false);
  }

  return (
    <div className="cookie-banner" role="region" aria-label={t("common.cookie_region")}>
      <p>{t("common.cookie_text")} <a href={policy} hrefLang={legalLinkLanguage(policy, language)} target="_blank" rel="noopener noreferrer">{t("common.footer_privacy")}</a></p>
      <Button size="small" onClick={accept}>{t("common.cookie_ok")}</Button>
    </div>
  );
}
